

export default function MenuItemsOrdenes(dispatch) {
    return [
        {
            label: "Nueva Orden de Venta",
            icon: "pi pi-fw pi-plus",
            // command: abrirVentanaCrearFia,
        },
        {
            label: "Listar Ordenes de Venta",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
        {
            label: "Nueva Orden de Cobro de Instalación",
            icon: "pi pi-fw pi-plus",
            // command: () => dispatch(new AbrirVentanaClienteAFacturar()),
        },
        {
            label: "Listar Ordenes de Cobro de Instalación",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        
    ];
}

